import pushDataLayer from "@ocm/services/dataLayer.js";
import * as utils from "@sharedJS/utils";
import EpoqPlpABTest from "@ocm/services/services.epoqPlpABTest";
import { getFavoriteBrandsToggleDimension } from "@ocm/services/services.favoriteBrandsToggleTracking";

const isEpoqRecosPlpEnabled = ocm.config.isEpoqRecosPlpEnabled;

function pushPageLoad(checkoutStep) {
	const products = [];

	try {
		const _cart = utils.getRecommendation().customerData.cart;

		const productList = _cart.products;

		for (let i = 0, max = productList.length; i < max; i++) {
			const _product = productList[i];

			let product = {
				id: _product.style,
				variant: _product.variant,
				name: _product.name,
				brand: _product.label,
				category: _product.categories[0],
				price: _product.price,
				quantity: _product.quantity,
				dimension1: _product.sale ? "1" : "0",
				dimension25: _product.vendorCode,
				dimension26: _product.vendorName,
				dimension30: _product.size,
			};

			if (isEpoqRecosPlpEnabled) {
				const trackingData = EpoqPlpABTest.getTrackingData(product.id);
				product = {
					...product,
					...trackingData,
				};
			}

			products.push(product);
		}
	} catch (e) {
		console.error("Error in dataLayer Checkout");
	}

	console.log("%c%s", "color:#fff;background-color:deeppink", "Checkout Event", products);
	const dataLayerObj = {
		event: "checkout",
		ecommerce: {
			...getFavoriteBrandsToggleDimension(),
			checkout: {
				actionField: { step: checkoutStep },
				products,
			},
		},
	};

	pushDataLayer(dataLayerObj);
}

// eslint-disable-next-line complexity
function pushPageLoadThankYouPage() {
	try {
		const _orderData = utils.getRecommendation().orderData;

		// 1) Zahlart zu Step 4

		const dataLayerCheckoutOption = {
			event: "checkoutOption",
			ecommerce: {
				...getFavoriteBrandsToggleDimension(),
				checkout_option: {
					actionField: { step: 4, option: _orderData.paymentMethod },
				},
			},
		};

		pushDataLayer(dataLayerCheckoutOption);

		// 2) Thank you
		const productList = _orderData.products;
		const products = [];

		for (let i = 0, max = productList.length; i < max; i++) {
			const _product = productList[i];

			let product = {
				id: _product.style,
				variant: _product.variant,
				name: _product.name,
				brand: _product.label,
				category: _product.categories[0],
				price: _product.price,
				quantity: _product.quantity,
				dimension1: _product.sale ? "1" : "0",
				dimension25: _product.vendorCode,
				dimension26: _product.vendorName,
				dimension30: _product.size,
			};

			if (isEpoqRecosPlpEnabled) {
				const trackingData = EpoqPlpABTest.getTrackingData(product.id);
				product = {
					...product,
					...trackingData,
				};
			}

			products.push(product);
		}

		const newCustomer = _orderData.type > 1 ? "0" : "1"; // '1'=Neukunden-Bestellung | '0'=Bestandskunden-Bestellung

		const voucherValue = _orderData.voucherValue ? _orderData.voucherValue : "";
		const voucherInternalName = _orderData.voucherInternalName ? _orderData.voucherInternalName : "";
		const voucher = _orderData.voucher ? _orderData.voucher : "";

		console.log("%c%s", "color:#fff;background-color:deeppink", "ThankYou Event", products);
		const dataLayerObj = {
			event: "checkout",
			ecommerce: {
				metric4: voucherValue, // Höhe des Gutscheins in EUR/ CHF
				dimension10: voucherInternalName, // internalName des Gutscheins
				dimension4: newCustomer, // '1'=Neukunden-Bestellung | '0'=Bestandskunden-Bestellung
				dimension11: _orderData.country, // Country der Bestellung DE/AT/CH
				dimension12: _orderData.zip, // PLZ der RE-Adresse der Bestellung bspw. '72555'
				...getFavoriteBrandsToggleDimension(),
				purchase: {
					actionField: {
						id: _orderData.orderID, // Transaction ID. Required for purchases and refunds.
						affiliation: "Online Store",
						revenue: _orderData.orderTotal, // Total transaction value (incl. tax and shipping)
						shipping: _orderData.shipping,
						coupon: voucher, // 3-stelliger Identifier des Vouchers
					},
					products,
				},
			},
		};

		pushDataLayer(dataLayerObj);
		// remove all products from AB test local storage
		const productIds = products.map((item) => item.id);
		EpoqPlpABTest.removeTrackingData(productIds);
	} catch (e) {
		console.error("Error in dataLayer Checkout");
	}
}

export { pushPageLoad, pushPageLoadThankYouPage };
